export default function valuesCss(unit: string, ...values: Array<number>) {

    return values.map(v => v ? `${v}${unit}` : "0").join(" ");
}